import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';
const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/profile.png`} alt="" />
      </Link>
      <header>
        <h2>Rupesh Khadka</h2>
        <p><a href="rupesh.khadka@gmail.com">rupesh.khadka@gmail.com</a></p>
      </header>
      <ContactIcons />
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Rupesh. I like learning and building things.
        I am a <a href="https://www.vu.edu.au/vu-sydney">Victoria University</a> graduate, and
        Machine Learning and environment enthusiast. Currently working at NexGenSm as a fullstack developer
        at <a href="https://nexgensm.com/">NexGenSm</a>
        ,  <a href="https://facebook.com">Facebook</a>
        , and <a href="https://www.linkedin.com/company/nexgensm/">LinkedIn</a>.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Rupesh&apos;Khadka <Link to="/">rupeshkhadka.com</Link>.</p>
    </section>
  </section>
);

export default SideBar;
